import React, { useRef } from "react";

const NEXT_KEYS = ["ArrowDown", "ArrowRight"];
const PREVIOUS_KEYS = ["ArrowUp", "ArrowLeft"];

/**
 * Wraps OptionCards as a radio group: arrow keys move to the next / previous option and select it,
 * like native radio buttons.
 */
function OptionGroup({ label, children }) {
  const groupRef = useRef(null);

  const moveSelection = (event) => {
    const step = NEXT_KEYS.includes(event.key) ? 1 : PREVIOUS_KEYS.includes(event.key) ? -1 : 0;
    if (!step) return;

    const options = Array.from(groupRef.current.querySelectorAll('[role="radio"]:not(:disabled)'));
    const current = options.indexOf(document.activeElement);
    if (current === -1) return;

    event.preventDefault();
    const next = options[(current + step + options.length) % options.length];
    next.focus();
    next.click();
  };

  return (
    <div ref={groupRef} className="kv-options" role="radiogroup" aria-label={label} onKeyDown={moveSelection}>
      {children}
    </div>
  );
}

export default OptionGroup;
